import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveDigitalPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['interrupter'] = function (block: Blockly.Block): [string, number] {
        const pin = resolveDigitalPin(block);
        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);
        return expr(`!digitalRead(${pin})`);
    };
}
